/**
 * Sorts routes by descending `priority` (routes with no `priority` are treated as `0`).
 *
 * Used in config/webpack/common/rules/loaders/routes-loader.ts.
 */
export function sortRoutes<ROUTE extends { priority?: number }>(routes: readonly ROUTE[]): readonly ROUTE[] {
	return [...routes].sort((a, b) => (b.priority || 0) - (a.priority || 0));
}
